import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Button, Space, Spin, Table } from "antd";

import AppButton from "components/button";
import ModalForm from "components/forms/components/modalForm";

import { setHeaderTitle } from "../../../stores/slices/layout";
import {
  doDeleteCardWorkspace,
  getWorkspaceInfo,
} from "../../../stores/slices/workspace";
import AddCard from "../payment/addCard";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY
);
// const { confirm } = Modal;

const CardPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isShowCardAdd, setIsShowCardAdd] = useState(false);
  const [loading, setLoading] = useState(true);
  // const [selectedCard, setSelectedCard] = useState();
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

  const columns = [
    {
      title: t("payment.cardHolder"),
      dataIndex: "cardHolder",
      key: "cardHolder",
    },
    {
      title: t("payment.last4Digit"),
      dataIndex: "stripLast4Digit",
      key: "stripLast4Digit",
    },
    {
      title: t("payment.actions"),
      key: "action",
      width: 170,
      render: () => (
        <Space size="small">
          <Button
            type="text"
            shape="circle"
            size="middle"
            onClick={() => {
              setIsShowCardAdd(true);
            }}
          >
            <EditOutlined />
          </Button>

          <Button
            type="text"
            shape="circle"
            size="middle"
            danger
            onClick={() => {
              setIsOpenModalDelete(true);
              // confirm({
              //   title: t("payment.deleteCard"),
              //   icon: <QuestionCircleOutlined style={{ color: "red" }} />,
              //   content: t("payment.deleteCardMsg"),
              //   okText: t("button.delete"),
              //   okType: "danger",
              //   cancelButtonProps: {
              //     disabled: isDeleting,
              //   },
              //   okButtonProps: {
              //     loading: isDeleting,
              //   },
              //   cancelText: t("button.cancel"),
              //   onOk() {
              //     setIsDeleting(true);
              //     handleDelete();
              //   },
              // });
            }}
          >
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  const handleDelete = async () => {
    const { payload } = await dispatch(doDeleteCardWorkspace(id));
    if (payload && payload.status === 200) {
      generateUI();
      setIsDeleting(false);
    } else {
      setIsDeleting(false);
    }
    setIsOpenModalDelete(false);
  };

  useEffect(() => {
    dispatch(setHeaderTitle(["workspaces", "card"]));
    generateUI();
  }, []);

  const generateUI = () => {
    setLoading(true);
    setIsShowCardAdd(false);
    getWorkspaceDetail().then(res => {
      console.log("getWorkspaceDetail", res);
      if (res.stripLast4Digit) {
        setData([
          {
            key: uuid(),
            cardHolder: res.cardHolder,
            stripLast4Digit: res.stripLast4Digit,
          },
        ]);
      } else {
        setData([]);
        setIsShowCardAdd(true);
      }
      setLoading(false);
    });
  };

  const getWorkspaceDetail = async () => {
    const payload = await dispatch(getWorkspaceInfo(id));
    return payload.payload;
  };

  const handleTitleDelete = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <QuestionCircleOutlined style={{ color: "red", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("payment.deleteCard")}
        </span>
      </div>
    );
  };

  return (
    <>
      {loading && (
        <div style={{ margin: "30px", width: "100%", textAlign: "center" }}>
          <Spin size="large" />
        </div>
      )}

      <div style={loading || !isShowCardAdd ? { display: "none" } : {}}>
        <Elements stripe={stripePromise}>
          <AddCard
            workspaceId={id}
            onSuccess={() => {
              generateUI();
            }}
            onCancel={() => {
              setIsShowCardAdd(false);
            }}
            isShowCancelButton={data && data[0]?.stripLast4Digit}
          />
        </Elements>
      </div>

      {!loading && !isShowCardAdd && data && (
        <div style={{ width: "70%", maxWidth: 800 }}>
          <Table columns={columns} dataSource={data} pagination={false} />
        </div>
      )}
      <ModalForm
        isOpen={isOpenModalDelete}
        type="confirm"
        title={handleTitleDelete()}
        onCancel={() => {
          setIsOpenModalDelete(false);
        }}
        okType={"danger"}
        danger={true}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("button.cancel")}
            color={"grey"}
            loading={isDeleting}
            disabled={isDeleting}
            htmlType="button"
            onClick={() => {
              setIsOpenModalDelete(false);
            }}
          />,
          <AppButton
            key="button"
            color="red"
            label={t("button.delete")}
            loading={isDeleting}
            disabled={isDeleting}
            onClick={() => {
              setIsDeleting(true);
              handleDelete();
            }}
          />,
        ]}
      >
        <div style={{ height: 50, marginLeft: 35, fontSize: 14 }}>
          {t("payment.deleteCardMsg")}
        </div>
      </ModalForm>
    </>
  );
};
export default CardPage;
